import "./PageNotFound.css";

function PageNotFound(): JSX.Element {
    return (
        <div className="PageNotFound">
			err 404
        </div>
    );
}

export default PageNotFound;
